import { defineComponent, computed } from 'vue';
import { HoursOfOperationDisplayType, ListingUtilities, Listing } from '@truckdown/locations';

const getComputed = function (listing: Listing) {
    let iconName = '',
        iconStyle = '',
        statusMessage = '',
        message = '',
        showHours = false;

    if (listing && listing.hours) {
        message = listing.hours.message;
        switch (listing.hours.type) {
            case HoursOfOperationDisplayType.Open: {
                iconName = 'faCircleCheck';
                iconStyle = 'icon open';
                statusMessage = 'Open';
                showHours = true;
                break;
            }
            case HoursOfOperationDisplayType.Closed: {
                iconName = 'faLock';
                iconStyle = 'icon closed';
                statusMessage = 'Closed'
                showHours = true;
                break;
            }
            case HoursOfOperationDisplayType.AfterHours: {
                iconName = 'faCircleExclamation';
                iconStyle = 'icon afterhours';
                let type = ListingUtilities.getAfterHoursStatusType(listing);
                statusMessage = ListingUtilities.getAfterHoursListingStatus(type);
                showHours = true;
                break;
            }
            default: {
                showHours = false;
                break;
            }
        }
    }

    return {
        iconName: computed(() => {
            return iconName;
        }),
        iconStyle: computed(() => {
            return iconStyle;
        }),
        statusMessage: computed(() => {
            return statusMessage;
        }),
        message: computed(() => {
            return message;
        }),
        showHours: computed(() => {
            return showHours;
        })
    };
}

export default defineComponent({
    props: {
        listing: Object
    },
    emits: [],
    setup: function (props, ctx) {
        let status = props.listing as Listing;
        var computed = getComputed(status);
        return {
            ...computed
        };
    }
});
